import { initSentry } from './lib/sentry'

initSentry()

import { StrictMode, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import BootError from './components/BootError.tsx'
import RootErrorBoundary from './components/RootErrorBoundary.tsx'
import {
  isTrainerPortal,
  markTrainerPortalSession,
  normalizeTrainerPortalPath,
  rerouteToTrainerPortalIfNeeded,
} from './lib/trainerPortal.ts'
import { supabaseConfigError } from './lib/supabaseClient.ts'
import { ensureServiceWorkerRegistered } from './lib/pushNotifications.ts'

void ensureServiceWorkerRegistered()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Missing #root element')
}

const bootShell = (child: ReactNode) => (
  <StrictMode>
    <RootErrorBoundary>
      {supabaseConfigError ? <BootError message={supabaseConfigError} /> : child}
    </RootErrorBoundary>
  </StrictMode>
)

if (rerouteToTrainerPortalIfNeeded()) {
  // Auth callback or /trainer shortcut — full navigation in progress.
} else if (isTrainerPortal()) {
  markTrainerPortalSession()
  normalizeTrainerPortalPath()
  void import('./trainer/TrainerApp.tsx').then(({ default: TrainerApp }) => {
    createRoot(rootElement).render(bootShell(<TrainerApp />))
  })
} else {
  createRoot(rootElement).render(bootShell(<App />))
}
